window.anvil.block('content-image-text', el => {
	const trigger = el.querySelector('.animate-trigger');
	const animate = el.querySelector('.animate');

	window.gsap.from(animate, {
		y: '100%',
		opacity: 0,
		duration: 0.8,
		ease: 'power3.out',
		scrollTrigger: {
			trigger: trigger,
			start: 'top 80%',
			end: 'bottom 80%',
			toggleActions: 'play none none none',
		}
	});

	const decoration_image = el.querySelector('.decoration-image');
	if (decoration_image) {
		const image_wrapper = el.querySelector('.image-wrapper');
		window.gsap.from(decoration_image, {
			y: '100%',
			duration: 0.8,
			ease: 'power3.out',
			scrollTrigger: {
				trigger: decoration_image,
				start: 'top 90%',
				end: 'bottom 70%',
				toggleActions: 'play none none none',
				scrub: true
			}
		});
	}

	const design_1 = el.querySelector('.design-1');
	if (design_1) {
		const image = design_1.querySelector('.main-image');
		const bg = design_1.querySelector('.image_bg');

		window.gsap.from(image, {
			rotation: -2,
			scrollTrigger: {
				trigger: design_1,
				start: 'top 80%',
				end: 'bottom 70%',
				scrub: 1,
			}
		});

		if (bg) {
			window.gsap.from(bg, {
				rotation: 5,
				scrollTrigger: {
					trigger: design_1,
					start: 'top 80%',
					end: 'bottom 70%',
					scrub: 1,
				}
			});
		}
	}
});
